export interface BuildEventDetailsQueryVariablesInput {
  pk: string;
  sk: string;
}

export const buildEventDetailsQueryVariables = ({
  pk,
  sk,
}: BuildEventDetailsQueryVariablesInput) => ({
  pk: encodeURIComponent(pk),
  sk: encodeURIComponent(sk),
});
